module.exports = __webpack_public_path__ + "img/20190704162154369.1511075f.png";